import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.CustomPricePoint.BulkUpdateCustomPricePoints.IRequest;
type Headers = Api.Core.CustomPricePoint.BulkUpdateCustomPricePoints.IHeaders;
type Response = Api.Core.CustomPricePoint.BulkUpdateCustomPricePoints.IResponse;
const url = '/api/ProductManagement/CustomPricePoint/BulkUpdateCustomPricePoints';
export async function bulkUpdateCustomPricePointsApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    body,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
